// Angular Files
import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-google-pay-mark',
    templateUrl: '../svgs/GooglePayMark.svg',
    host: { class: 'teller-online-icon teller-online-icon--google-pay-mark' }
})
export class TellerOnlineIconGooglePayMarkComponent {}
